import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, pipe, of, BehaviorSubject } from 'rxjs';
import { Account } from './model/account';
import { ApiRoutes } from 'src/app/config/api-routes';
import { tap, catchError, map } from 'rxjs/operators';
import { CreateAccountDTO } from './components/create-account-modal/model/create-account.dto';

@Injectable()
export class AccountsService {
  public updated$: Subject<any> = new Subject<any>();
  public accountsCache$: BehaviorSubject<Account[]> = new BehaviorSubject<Account[]>([]);

  constructor(
    private httpClient: HttpClient,
    private config: ApiRoutes,
  ) { }

  public getAccounts(): Observable<Account[]> {
    return this.httpClient
      .get<Account[]>(this.config.LOGIN)
      .pipe(catchError(() => of([])));
  }

  public getAccount(id: string): Observable<Account> {
    return this.httpClient.get<Account>(ApiRoutes.getRouteWithInjectedParams(this.config.LOGIN_DETAILS, [id]));
  }

  public createAccount(account: CreateAccountDTO): Observable<Account> {
    return this.httpClient.post<Account>(this.config.LOGIN, account);
  }

  public updateAccount(account: Account) {
    return this.httpClient.put(this.config.LOGIN, account)
      .pipe(
        tap(() => this.updated$.next(null)),
      );
  }

  public sendInvitationMail(id: any) {
    return this.httpClient.get<Account>(ApiRoutes.getRouteWithInjectedParams(this.config.LOGIN_INVITE, [id]));
  }

  public checkUsernameValidation(username: string): Observable<any> {
    return this.httpClient.get(this.config.LOGIN_VALIDATE_USERNAME + '?username=' + encodeURIComponent(username));
  }

  public reloadCacheIfLoginIdNotFound(loginIds: number[]) {
    const cachedLoginIds = this.accountsCache$.value.map(x => x.id);

    if (loginIds.some(loginId => !cachedLoginIds.includes(loginId))) {
      this.getAccounts()
        .subscribe(accounts => this.accountsCache$.next(accounts));
    }
  }

  public getAccountLabel(account: Account) {
    if (account && account.firstName && account.lastName) {
      return account.firstName + ' ' + account.lastName;
    } else if (account) {
      return account.username;
    } else {
      return '';
    }
  }
}
